// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1___18f79f0f3de9b20aec1","cls2":"LanguageSwitcherModal-cls2__c4331f9183adc2a34dd1 LanguageSwitcherModal-cls1___18f79f0f3de9b20aec1"};